import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export type TState = {
  appVersion: string;
  successfulRegistrationModalOpen: boolean;
};

const initialState: TState = {
  appVersion: '',
  successfulRegistrationModalOpen: false,
};

type TActions = {
  setSuccessfulRegistrationModalOpen: (modalOpen: boolean) => void;
  setAppVersion: (appVersion: string) => void;
};

type TStore = TState & TActions;

const useCommonStore = create(
  immer<TStore>((set) => ({
    ...initialState,

    setAppVersion: (appVersion) => {
      set((state) => {
        state.appVersion = appVersion;
      });
    },

    setSuccessfulRegistrationModalOpen: (modalOpen) => {
      set((state) => {
        state.successfulRegistrationModalOpen = modalOpen;
      });
    },
  }))
);

export default useCommonStore;
